// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EtU3rNX9KYwOQ68fVLN1{word-break:break-word;text-align:left;width:100%;margin:-2px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `EtU3rNX9KYwOQ68fVLN1`
};
export default ___CSS_LOADER_EXPORT___;
